export function ChromeStar({ className = '', spin = false }) {
  return (
    <svg
      viewBox="0 0 100 100"
      aria-hidden="true"
      className={`${className} ${spin ? 'animate-spin-slow' : ''}`}
    >
      <defs>
        <linearGradient id="chrome-star-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#f8fafc" />
          <stop offset="0.3" stopColor="#94a3b8" />
          <stop offset="0.52" stopColor="#ffffff" />
          <stop offset="0.74" stopColor="#64748b" />
          <stop offset="1" stopColor="#e2e8f0" />
        </linearGradient>
      </defs>
      <path
        d="M50 2 C56 34 66 44 98 50 C66 56 56 66 50 98 C44 66 34 56 2 50 C34 44 44 34 50 2 Z"
        fill="url(#chrome-star-grad)"
        stroke="rgba(10,10,10,0.28)"
        strokeWidth="0.6"
      />
    </svg>
  );
}
